import { LocalLogger } from "@/classes/LocalLogger";

const localLogger = new LocalLogger();

export { localLogger };
